import React, { useEffect, useState } from 'react';
import { getAnalyticsConsent, setAnalyticsConsent } from '@/services/analytics';

const AnalyticsConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getAnalyticsConsent() === null) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    setAnalyticsConsent(true);
    setVisible(false);
  };

  const decline = () => {
    setAnalyticsConsent(false);
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 border-t"
      style={{ background: 'rgba(18,18,20,0.97)', borderColor: 'rgba(255,193,7,0.25)' }}
    >
      <div className="max-w-2xl mx-auto">
        <p className="text-sm text-foreground/80 mb-3">
          Octoveto utilise des outils d'analyse (Amplitude) pour améliorer l'application.
          Ces données restent anonymisées et ne sont jamais revendues.{' '}
          <a href="/privacy" className="text-primary underline">En savoir plus</a>
        </p>
        <div className="flex gap-3 flex-wrap">
          <button
            onClick={accept}
            className="px-4 py-2 rounded-full text-sm font-semibold text-black"
            style={{ background: 'linear-gradient(135deg, #FFC107 0%, #FF8F00 100%)' }}
          >
            Accepter
          </button>
          <button
            onClick={decline}
            className="px-4 py-2 rounded-full text-sm font-medium text-foreground/70 border border-white/15 hover:bg-white/5 transition-colors"
          >
            Refuser
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsentBanner;
